import { PrintIcon } from "assets/icons";
import { BoxShadowLayout, ContentLayout } from "layouts";
import { useManageTable } from "hooks";
import moment from "moment";
import {
  COMPANY_DELIVERIES_LABELS,
  DeliveryCompaniesTable
} from "modules/financial";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { Value } from "react-date-picker/dist/cjs/shared/types";
import { Button, DateRangeInput, SearchInput } from "ui";

import { useCompanyFinanceDrivers, useCompanyFinanceReport } from "../../apis";
import { useCurrentPortalUser } from "../../hooks";

import styles from "./CompanyFinance.module.scss";

const CompanyFinance = () => {
  const { t } = useTranslation();
  const { company } = useCurrentPortalUser();
  const { searchValue, setSearchValue, debouncedSearch } = useManageTable();

  const [dateRange, setDateRange] = useState<Value>(null);

  const requestParams = {
    search: debouncedSearch,
    from:
      Array.isArray(dateRange) && dateRange[0]
        ? moment(dateRange[0]).format("YYYY-MM-DD")
        : moment().subtract(10, "year").format("YYYY-MM-DD"),
    to:
      Array.isArray(dateRange) && dateRange[1]
        ? moment(dateRange[1]).format("YYYY-MM-DD")
        : moment().add(1, "year").format("YYYY-MM-DD")
  };

  const companyId = company?.id ?? "";

  const { drivers, isLoading } = useCompanyFinanceDrivers(
    companyId,
    requestParams
  );

  const report = useCompanyFinanceReport(companyId, requestParams, dateRange);

  return (
    <ContentLayout title={t("Deliveries")}>
      <BoxShadowLayout className={styles.pageContent}>
        <div className={styles.pageContent_tableHeader}>
          <SearchInput
            value={searchValue}
            onChange={setSearchValue}
            placeholder={t("Search...")}
          />

          <div className={styles.pageContent_tableHeader_rightBlock}>
            <DateRangeInput value={dateRange} onChange={setDateRange} />

            <Button
              className={styles.pageContent_tableHeader_printBtn}
              icon={<PrintIcon />}
              disabled={!drivers || report.isLoading}
              onClick={() => report.mutate()}
            >
              {t("Print Report")}
            </Button>
          </div>
        </div>

        <DeliveryCompaniesTable
          items={drivers ?? []}
          isLoading={isLoading}
          labels={COMPANY_DELIVERIES_LABELS}
          getDriverPath={(driverId) => `/company/financial/${driverId}`}
        />
      </BoxShadowLayout>
    </ContentLayout>
  );
};

export default CompanyFinance;
